// @flow

export const FIELD_TYPE_DATE: 'date' = 'date';
export const FIELD_TYPE_ENUM: 'enum' = 'enum';
export const FIELD_TYPE_INTEGER: 'integer' = 'integer';
export const FIELD_TYPE_FLOAT: 'float' = 'float';
export const FIELD_TYPE_MULTISELECT: 'multiSelect' = 'multiSelect';
export const FIELD_TYPE_STRING: 'string' = 'string';
export const TEMPLATE_CUSTOM_PROPERTIES: 'properties' = 'properties';
export const JSON_PATCH_OP_ADD: 'add' = 'add';
export const JSON_PATCH_OP_REMOVE: 'remove' = 'remove';
export const JSON_PATCH_OP_REPLACE: 'replace' = 'replace';
export const JSON_PATCH_OP_TEST: 'test' = 'test';
